import { ChartOfAccountsTemplateHeader } from "@common/schemas/chart-of-accounts-template.schema";
import { ChartOfAccountsTemplate } from "@common/types/chartOfAccountsTemplate";
import { ChartOfAccountsTemplateRoleSelectionStep } from "./ChartOfAccountsTemplateRoleSelectionStep";
import { ChartOfAccountsTemplateUploadSteps } from "./ChartOfAccountsTemplateUploadSteps";
import { useChartOfAccountsTemplateUploadFlow } from "./useChartOfAccountsTemplateUploadFlow";

interface Props {
    header: ChartOfAccountsTemplateHeader;
    onClose: () => void;
    onCreated: (template: ChartOfAccountsTemplate) => void;
}

export const ChartOfAccountsTemplateUploadFlow = ({
    header,
    onClose,
    onCreated,
}: Props) => {
    const flow = useChartOfAccountsTemplateUploadFlow();
    const { step } = flow;

    return (
        <>
            <ChartOfAccountsTemplateUploadSteps
                title="Import Chart of Accounts"
                flow={flow}
                onClose={onClose}
                onTypesConfirmed={flow.continueToRoleSelection}
            />
            {step.name === "roleSelection" && (
                <ChartOfAccountsTemplateRoleSelectionStep
                    chart={step.chart}
                    header={header}
                    isDiscardPromptOpen={flow.isDiscardPromptOpen}
                    onClose={() => flow.requestClose(onClose)}
                    onCreated={onCreated}
                />
            )}
        </>
    );
};
